import type { AppSelector, DashboardState, OutageType } from "src/types";

const getModel: AppSelector<DashboardState> = (state) => state.dashboard;

export const getWeekOffset: AppSelector<number> = (state) => getModel(state).weekOffset;
export const getActiveOutageType: AppSelector<OutageType | null> = (state) => getModel(state).activeOutageType;
